export default [
    {
        id: 1,
        text: 'public.time',
        type: 'datetimerange',
        paramsName: 'time',
        isChooze: true
    },
    {
        id: 2,
        text: 'integration.abnormal',
        type: 'select',
        paramsName: 'isEx',
        selectParam: [
            {
                id: 1,
                icon: '',
                value: '',
                label: 'public.please'
            },
            {
                id: 2,
                icon: '',
                value: 0,
                label: $t('public.btn_no')
            },
            {
                id: 3,
                icon: '',
                value: 1,
                label: $t('public.btn_yes')
            }
        ],
        isChooze: false
    },
    {
        id: 3,
        text: $t('integration.storage'),
        type: 'select',
        paramsName: 'isStore',
        selectParam: [
            {
                id: 1,
                icon: '',
                value: '',
                label: 'public.please'
            },
            {
                id: 2,
                icon: '',
                value: 0,
                label: $t('public.btn_no')
            },
            {
                id: 3,
                icon: '',
                value: 1,
                label: $t('public.btn_yes')
            }
        ],
        isChooze: false
    }
];
